import styled from 'styled-components';
import {justifyEnd} from '../../../globalVariables/GlobalFlex';
import {bottom} from '../../popupAfterAdvertise/privateEvent/BottomSection.css';
import {GRAY, mobileMedia, scrollbar, WHITE} from '../../../globalVariables/GlobalVariables';
import {btn} from '../../button/btn/Btn.css';

export const contentContainer = styled.div`
    position: relative;
    inset-block-start: 80px;
    padding: 0 30px 30px;
    ${scrollbar};
    ${mobileMedia}{
        padding: 0 20px 20px;
    }
`;

export const previewContent = styled.div`
    border: 0.5px solid ${GRAY};
    border-radius: 10px;
    padding: 20px;
`;

export const buttonContainer = styled(bottom)`
    gap: 10px;
    ${justifyEnd};
    padding-inline: 30px;
    ${btn}{
        &.white{
            background-color: ${WHITE}
        }
    }
`;
